import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

export const Container = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;

  color: #4585ff;
  font-size: 12px;
  font-family: ${fontRoboto};

  & svg {
    margin-inline-start: 6px;
  }
`;
